import Layout from "@/layout"

const vpSwDebugRouter = {
    path: "/vp-sw",
    component: Layout,
    redirect: "noRedirect",
    name: "VP & SW Debug",
    meta: {
        title: "VP & SW Debug",
        icon: "bug"
    },
    children: [
        {
            path: "virtual-platform",
            component: () => import("@/views/vp-sw/VirtualPlatform"),
            name: "Virtual Platform",
            meta: {
                title: "Virtual Platform",
            }
        },
        {
            path: "sw-debug",
            component: () => import("@/views/vp-sw/SwDebug"),
            name: "SWDebug",
            meta: {
                title: "SW Debug",
                keepAlive: true
            }
        }
    ]
}

export default vpSwDebugRouter